import useViewContext from '/druid/internal/useViewContext';

export default function useScrolling() {
  const { scrolling } = useViewContext();

  return [scrolling];
}
